import { supabase } from '../../config/supabase';

/**
 * Track a delivery using the public short ID (no authentication required)
 * @param {string} shortId - The short tracking ID
 * @returns {Promise<Object>} Tracking information with delivery photos
 */
export const trackDelivery = async (shortId) => {
  try {
    const { data, error } = await supabase
      .from('public_jobs')
      .select('*')
      .eq('short_id', shortId.toUpperCase())
      .single();

    if (error) throw error;

    // Parse delivery_photos JSON if it exists
    if (data && data.delivery_photos) {
      try {
        data.delivery_photos = typeof data.delivery_photos === 'string' 
          ? JSON.parse(data.delivery_photos) 
          : data.delivery_photos;
      } catch (e) {
        console.error('Error parsing delivery photos:', e);
        data.delivery_photos = [];
      }
    } else {
      data.delivery_photos = [];
    }

    return { data, error: null };
  } catch (error) {
    console.error('Error tracking delivery:', error);
    return { data: null, error };
  }
};